import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex';
import { IEDate, uGetDateFormat, uGetTimeArray } from '@appbase/util';
import * as types from '@reserve/store/types'
import { openReserveCalendarItem, openReserveResourceTime } from '@reserve/popup-handler';
import modalHelper from '@appbase/util/modal-helper';

import OccurrenceSelect from '@reserve/components/OccurrenceSelect.vue';
import EventItem from '@reserve/components/MergeView/EventItem.vue';

/*const IsPastAlldayEvent = function(currentDate: Date, e: reserve.CalendarItem): boolean {
    if(e.isAllDayEvent) {
        let dateKey = uGetDateFormat('yyyy-MM-dd', IEDate(currentDate));
        let itemKey = uGetDateFormat('yyyy-MM-dd', IEDate(e.start));

        return dateKey !== itemKey;
    } else {
        return false;
    }        
}*/

@Component({
    components: {
        EventItem
    },

    computed: mapGetters({
        currentDate: types.CALENDAR_DATE_CURRENT,
        dailyEvents: types.CALENDAR_DAILY_EVENT_LIST
    })
})
export default class ResourceLine  extends Vue {
    @Prop({ type: Object }) resource!: reserve.ResourceItemBase;

    currentDate!: reserve.DateItem;
    dailyEvents!: reserve.ItemList<reserve.CalendarItem>;

    timeArray: reserve.TimelineItem[] = [];    
    timelineEvents: { [key:string]: reserve.CalendarItem[] } = {};

    @Watch('dailyEvents')
    onEventsChanged(newVal: reserve.ItemList<reserve.CalendarItem>) {
        this.mountEvents(newVal);
    }

    created() {
        this.timeArray = uGetTimeArray([
            this.$t('W_AM').toString(),
            this.$t('W_PM').toString()
        ]);                   
                
        this.mountEvents(this.dailyEvents);
    }

    mountEvents(events: reserve.ItemList<reserve.CalendarItem>) {
        this.timelineEvents = {};

        /*let resourceEvents = events.filter(e =>
            e.resourceUpn.toLowerCase() === this.resource.address.toLowerCase() &&
            !IsPastAlldayEvent(this.currentDate.date, e) &&
            !e.isCancelled);

        if(resourceEvents.length > 0) {
            for(let i =0; i < resourceEvents.length; i++) {
                const event = resourceEvents[i];
                let removeFlag = false;
                let IsAtLeastOneDate = false;

                if (event.scheduleDuration) {
                    let dayCount = Number(event.scheduleDuration.split('.')[0]);
                    if (dayCount > 1 && !isNaN(dayCount)) {
                        removeFlag = true;
                    }
                }

                if (removeFlag) {
                    resourceEvents.splice(i, 1);
                    i--;
                }
            }
        }

        this.timeArray.forEach(t => {
            let dateString = uGetDateFormat('yyyy-MM-dd', IEDate(this.currentDate.date));
            let timeString = t.value;
            let dateKey = `${dateString}T${timeString}`;

            this.timelineEvents[t.value] = resourceEvents.filter(e => dateKey ===
                `${uGetDateFormat('yyyy-MM-dd', IEDate(e.start))}T${uGetDateFormat('H:i:00', IEDate(e.start))}`);
        });*/

        let resourceEvents = events.filter(e =>
            e.resourceUpn.toLowerCase() === this.resource.address.toLowerCase() &&
            !e.isCancelled // 취소된 일정은 제외
        );

        if (resourceEvents.length > 0) {
            for (let i = 0; i < resourceEvents.length; i++) {
                const event = resourceEvents[i];

                if (event.scheduleDuration) {
                    let dayCount = Number(event.scheduleDuration.split('.')[0]);
                    if (dayCount > 1 && !isNaN(dayCount)) {
                        // 다중일 일정도 유지, 제거하지 않음
                        continue;
                    }
                }
            }
        }

        let allDayEventAdded = false;

        /*this.timeArray.forEach(t => {
            let dateString = uGetDateFormat('yyyy-MM-dd', IEDate(this.currentDate.date));
            let timeString = t.value;
            let dateKey = `${dateString}T${timeString}`;

            if (!allDayEventAdded) {
                // 하루 종일 이벤트 추가
                this.timelineEvents[t.value] = resourceEvents.filter(e => {
                    let eventStart = new Date(e.start);
                    let eventEndDate = e.scheduleDuration
                        ? uGetDateFormat('yyyy-MM-dd', IEDate(new Date(eventStart.getTime() + (Number(e.scheduleDuration.split('.')[0]) - 1) * 24 * 60 * 60 * 1000)))
                        : eventStart;

                    // 하루 종일 이벤트는 날짜 범위만 확인
                    if (e.isAllDayEvent) {
                        allDayEventAdded = true; // 하루 종일 이벤트가 추가되었음을 표시
                        return dateString >= uGetDateFormat('yyyy-MM-dd', IEDate(eventStart)) && dateString <= eventEndDate;
                    }

                    // 일반 이벤트: 시간대와 날짜 일치 여부 확인
                    return dateString >= uGetDateFormat('yyyy-MM-dd', IEDate(eventStart)) && dateString <= eventEndDate &&
                        dateKey === `${uGetDateFormat('yyyy-MM-dd', IEDate(eventStart))}T${uGetDateFormat('H:i:00', IEDate(eventStart))}`;
                });
            }
        });*/

        this.timeArray.forEach(t => {
            let dateString = uGetDateFormat('yyyy-MM-dd', IEDate(this.currentDate.date)); // 현재 날짜
            let timeString = t.value; // 시간 슬롯 (예: "08:30")
            let dateKey = `${dateString}T${timeString}`; // 현재 날짜와 시간의 키

            // 각 날짜의 첫 번째 슬롯(또는 시작 시간 슬롯)에만 이벤트를 추가
            this.timelineEvents[t.value] = resourceEvents.filter(e => {
                let eventStart = new Date(e.start);  // 이벤트 시작 시간
                let eventEnd = new Date(e.end || eventStart);  // 이벤트 종료 시간 (종료 시간이 없으면 시작 시간)
                let eventStartDate = uGetDateFormat('yyyy-MM-dd', IEDate(eventStart)); // 이벤트 시작 날짜
                let eventStartTime = uGetDateFormat('H:i:00', IEDate(eventStart)); // 이벤트 시작 시간 (HH:mm:ss)
                let eventEndDate = uGetDateFormat('yyyy-MM-dd', IEDate(eventEnd)); // 이벤트 종료 날짜

                // 하루 종일 이벤트 처리
                if (e.isAllDayEvent) {
                    if (!allDayEventAdded) {
                        allDayEventAdded = true; // 하루 종일 이벤트가 추가되었음을 표시
                        return dateString >= eventStartDate && dateString <= eventEndDate;
                    }
                    return false; // 하루 종일 이벤트는 한 번만 추가
                }

                // 일반 이벤트 처리
                if (dateString >= eventStartDate && dateString <= eventEndDate) {
                    // 시작일의 경우: 지정된 시작 시간에만 표시
                    if (dateString === eventStartDate) {
                        return timeString === eventStartTime; // 이벤트 시작 시간과 슬롯이 같을 때 추가
                    }
                    // 그 외의 날짜: 첫 번째 시간 슬롯(00:00)에 표시
                    return timeString === this.timeArray[0].value; // 첫 번째 슬롯인 경우만 추가
                }
                return false; // 날짜 범위에 포함되지 않는 경우
            });
        });
    }
    
    onTimeDblClick(time: reserve.TimelineItem, idx: number) {        
        let curDateStr = uGetDateFormat('yyyy-MM-dd', IEDate(this.currentDate.date));
        let dblStartTime = `${curDateStr}T${time.value}`;
        let dblEndTime = `${curDateStr}T${this.timeArray[idx + 1].value}`;
        
        openReserveResourceTime(this.resource.comCode, IEDate(dblStartTime), IEDate(dblEndTime), this.resource.itemStore, this.resource.address);
    } 

    onEventDblClick(event: reserve.CalendarItem) {
        if (event.appointmentType === 'Occurrence' || event.appointmentType === 'Exception') {
            modalHelper.show({ component: OccurrenceSelect, force: true, value: event });
        } else {
            openReserveCalendarItem(event);
        }     
    }
}